import type { PackageManager } from '@cli-types/core-engine/utils.js'
import type { InstallDepsResult } from '@cli-types/next-adapter/init.js'
import { getCliDependencySyncPlan } from './get-cli-dependency-sync-plan.js'
import { installDependenciesAsync } from './install-dependencies-async.js'

export async function syncProjectCliDependency(
  cwd: string,
  pm: PackageManager
): Promise<InstallDepsResult | null> {
  const dependencyPlan = getCliDependencySyncPlan(cwd)
  if (!dependencyPlan) {
    return null
  }

  return installDependenciesAsync({
    cwd,
    pm,
    dependencies: dependencyPlan.dependencies,
    devDependencies: dependencyPlan.devDependencies
  })
}
